"use client";
import { Box, Separator, Grid, GridItem, HStack, Stack } from "@chakra-ui/react";
import Image from "next/image";
import PageLayout from "@/layouts/pageLayout";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { LIST_CONSTANTS, FOOTER_CONSTANTS } from "./constants";

const ListComp = () => {
  const { heading, items } = LIST_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  return (
    <Box bg="#F4F7FA" py={14} mt={20}>
      <PageLayout>
        <Heading variant={HeadingVariant} textAlign={"center"}>
          {heading}
        </Heading>
        <Grid
          templateColumns={{
            base: "repeat(1, 1fr)",
            md: "repeat(2, 1fr)",
          }}
          gap={16}
          maxW={"5xl"}
          mx="auto"
        >
          {items.map((item, index) => (
            <GridItem key={index} maxW={"sm"}>
              <HStack gap={4} alignItems="flex-start">
                <Box width={"120px"} height={"55px"} position="relative">
                  <Image
                    src={item.image}
                    alt={item.label}
                    fill
                    style={{ objectFit: "cover" }}
                  />
                </Box>
                <Stack gap={4} py={1}>
                  <Text variant={TextVariant} fontSize="lg" fontWeight={700}>
                    {item.label}
                  </Text>
                  <Text variant={"body2"} color="text.100">
                    {item.text}
                  </Text>
                </Stack>
              </HStack>
            </GridItem>
          ))}
        </Grid>
        <Separator borderWidth="2px" borderColor="#ECECEC" my={4} />
        <Stack
          direction={{ base: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems="center"
          gap={6}
          maxW={"6xl"}
          mx="auto"
          w="full"
        >
          <Box>
            <Heading variant={"headLine3"} fontWeight={600} mb={8}>
              {FOOTER_CONSTANTS.heading}
            </Heading>
            <Text variant={"body2"} color="text.100" maxW="2xl">
              {FOOTER_CONSTANTS.text}
            </Text>
          </Box>
          <Button
            onClick={() => scrollToElement("contact-us", 120)}
            variant={"ideal"}
            fontSize="lg"
          >
            {FOOTER_CONSTANTS.btn.label}
          </Button>
        </Stack>
      </PageLayout>
    </Box>
  );
};

export default ListComp;
